/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { LandingFAQ } from './model/landingFAQ';

/**
 * Returns fact interpolated FAQs for a given service landing page.
 */
export const apiFrontendServiceLandingLocaleFaqsList = (
  countryUrlPrefix: string,
  language: string,
  serviceLandingSlug: string,
  signal?: AbortSignal
) => {
  return HTTP<LandingFAQ[]>({
    url: `/api/v7/frontend/service-landing/${countryUrlPrefix}/${language}/${serviceLandingSlug}/faqs/`,
    method: 'GET',
    signal,
  });
};

export const getApiFrontendServiceLandingLocaleFaqsListQueryKey = (
  countryUrlPrefix?: string,
  language?: string,
  serviceLandingSlug?: string
) => {
  return [
    `/api/v7/frontend/service-landing/${countryUrlPrefix}/${language}/${serviceLandingSlug}/faqs/`,
  ] as const;
};

export const getApiFrontendServiceLandingLocaleFaqsListQueryOptions = <
  TData = Awaited<ReturnType<typeof apiFrontendServiceLandingLocaleFaqsList>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  language: string,
  serviceLandingSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFrontendServiceLandingLocaleFaqsList>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiFrontendServiceLandingLocaleFaqsListQueryKey(
      countryUrlPrefix,
      language,
      serviceLandingSlug
    );

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof apiFrontendServiceLandingLocaleFaqsList>>
  > = ({ signal }) =>
    apiFrontendServiceLandingLocaleFaqsList(countryUrlPrefix, language, serviceLandingSlug, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(countryUrlPrefix && language && serviceLandingSlug),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiFrontendServiceLandingLocaleFaqsList>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiFrontendServiceLandingLocaleFaqsListQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiFrontendServiceLandingLocaleFaqsList>>
>;
export type ApiFrontendServiceLandingLocaleFaqsListQueryError = ErrorType<unknown>;

export function useApiFrontendServiceLandingLocaleFaqsList<
  TData = Awaited<ReturnType<typeof apiFrontendServiceLandingLocaleFaqsList>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  language: string,
  serviceLandingSlug: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiFrontendServiceLandingLocaleFaqsList>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiFrontendServiceLandingLocaleFaqsListQueryOptions(
    countryUrlPrefix,
    language,
    serviceLandingSlug,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
